



























import {Vue, Component, Prop} from 'vue-property-decorator'
import '@/assets/fonts/blender-mouse-hints-icon-font/css/blender-mouse-hints.css'
import {nglStore, userStore} from '@/store'
import {MouseControls} from '@/mouse-controls'
import CamTrackIndicator from '@/components/CamTrackIndicator.vue'

@Component({
  name: 'NGLMouseHints',
  components: {
    CamTrackIndicator,
  }
})
export default class NGLMouseHints extends Vue {
  @Prop()
  mouseControls!: MouseControls | null

  get ctrl() {
    return nglStore.keyboard.ctrl
  }

  get shift() {
    return nglStore.keyboard.shift
  }

  get ctrlPressed() {
    return this.ctrl && !this.shift
  }

  get shiftPressed() {
    return !this.ctrl && this.shift
  }

  get ctrlShiftPressed() {
    return this.ctrl && this.shift
  }

  get mouseControlMode() {
    return userStore.uiStateShotDesignerMouseControllerMode
  }

  get followCameraTrackMode() {
    return userStore.profile?.ui.shotDesigner.followCameraTrackMode
  }

  get mouseActions() {
    if (this.mouseControls && this.mouseControlMode) {
      if (this.mouseControlMode === 'view' && this.followCameraTrackMode)
        return []               // no mouse actions in followCameraTrackMode
      return this.mouseControls.mouseActionsByMode[this.mouseControlMode]
    }
    return []
  }

  get mouseActionsLeft() {
    if (this.mouseActions.length) {
      return this.mouseActions
        .filter((action: any[]) => action[0].includes('drag-left'))
        .filter((action: any[]) => (this.ctrlPressed ? action[0].startsWith('ctrl-') : !action[0].startsWith('ctrl-')))
        .map((action: any[]) => (action[2] ? action[2].replace('-', ' ') : ''))
    }
    return []
  }

  get mouseActionsRight() {
    if (this.mouseActions.length) {
      return this.mouseActions
        .filter((action: any[]) => action[0].includes('drag-right'))
        .filter((action: any[]) => (this.ctrlPressed ? action[0].startsWith('ctrl-') : !action[0].startsWith('ctrl-')))
        .map((action: any[]) => (action[2] ? action[2].replace('-', ' ') : ''))
    }
    return []
  }

  get mouseActionsScroll() {
    if (this.mouseActions.length) {
      return this.mouseActions
        .filter((action: any[]) => action[0] === 'scroll')
        .map((action: any[]) => (action[2] ? action[2].replace('-', ' ') : ''))
    }
    return []
  }

  get leftIconClass() {
    return {
      active: nglStore.mouse.left
    }
  }

  get rightIconClass() {
    return {
      active: nglStore.mouse.right
    }
  }

  /** If we're in followCameraTrack mode, flash the indicator when the user
      tries to zoom/pan/rotate, since those won't work. */
  notifyMotion() {
    if (this.followCameraTrackMode)
      (this.$refs.camTrackIndicator as any).highlight()
  }
}
